import {Modal} from "antd";
import {FormattedMessage} from "react-intl";

const RegisterModal = (props) => {
    const {brandName, oldAdminPanel, brandSettings, crm_url, isRegisterModalVisible, toggleRegisterModal} = props;

    let isBrandSettingsSet = Object.keys(brandSettings).length > 0;

    let company_name_short = isBrandSettingsSet && brandSettings?.companyNameShort;
    let live_register_link = `${crm_url}/#/register?type=individual`;
    let demo_register_link = `${crm_url}/#/register?type=demo`;

    if (oldAdminPanel) {
        company_name_short = isBrandSettingsSet && brandSettings.company_name_short;
        live_register_link = `${crm_url}/#/user/register`;
        demo_register_link = `${crm_url}/#/user/register-demo`;
    }

    return (
        <Modal
            centered
            title="Register Now"
            open={isRegisterModalVisible}
            onOk={toggleRegisterModal}
            onCancel={toggleRegisterModal}
            footer={false}
            // transitionName=""
            // wrapClassName={customAntModalWrap}
            // style={{transformOrigin: `1030px ${modalPosition}px`, marginTop: `${modalPosition}px` }}
            // style={{ top: `${modalPosition}px` }}
        >
            <div className="pb-5">
                <div>
                    <FormattedMessage
                        id="modal.register.para_1"
                        values={{
                            company_name_short: company_name_short,
                        }}
                    />
                </div>
                <div className="my-4">
                    <FormattedMessage id="modal.register.para_2" />
                </div>

                <div className="bold_text text-center">
                    <FormattedMessage id="modal.register.para_3" />
                </div>
                {isBrandSettingsSet && brandSettings.live_account_registration && (
                    <div className="mt-5 text-center">
                        <a href={live_register_link} target="_blank" className={`primary_btn ${brandName}`} rel="noreferrer">
                            <FormattedMessage id="modal.register.start_trading_now" />
                        </a>
                    </div>
                )}
                {isBrandSettingsSet && brandSettings.demo_account_registration && (
                    <div className="text-center my-3">
                        <span>
                            <FormattedMessage id="commons.or" />
                        </span>
                        <a href={demo_register_link} target="_blank" rel="noreferrer" className="mx-1">
                            <FormattedMessage id="modal.register.try_demo_account" />
                        </a>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default RegisterModal;
